import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoanIneligible = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6450_157666)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
			fill: "#B2002D"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M5.2666 9.66699H11.334V10.334H5.2666L6.93359 12H6L4 10L6 8H6.93359L5.2666 9.66699ZM12 6L10 8H9.06738L10.7334 6.33398H4.66699V5.66699H10.7334L9.06738 4H10L12 6Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6450_157666",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgLoanIneligible;
